import { parseCommentContent } from "@/utils/commentUtils";

interface CommentContentProps {
	content: string;
	className?: string;
}

export const CommentContent = ({ content, className = "" }: CommentContentProps) => {
	const parsedContent = parseCommentContent(content);

	return (
		<div 
			className={`prose prose-sm max-w-none ${className}`}
			dangerouslySetInnerHTML={{ __html: parsedContent }}
		/>
	);
};
